export const getAccessToken = () => {
  if (typeof window === "undefined") {
    return null;
  }
  const token = localStorage.getItem("okta-anonymous-access-token");
  if (token) {
    return { token };
  }
};

export const getRequiredSpecification = (
  attr = [],
  toMatch = "",
  matchIndex = 0,
  fetchIndex = 0
) => {
  return attr
    .map(s => s.split("|"))
    .find(parts => parts[matchIndex] === toMatch)?.[fetchIndex];
};

export const getRequiredPrice = (
  attr = [],
  toMatch = "",
  matchIndex = 0,
  fetchIndex = 0
) => {
  return attr
    .map(s => s.split("|"))
    .find(parts => parts[matchIndex] === toMatch)?.[fetchIndex];
};

export const vietnameseMonths = [
  "tháng Giêng",
  "tháng hai",
  "tháng ba",
  "tháng tư",
  "tháng năm",
  "tháng sáu",
  "tháng bảy",
  "tháng tám",
  "tháng chín",
  "tháng mười",
  "tháng mười một",
  "tháng mười hai",
];

export const getFormattedDate = (locale, d) => {
  const date = new Date(d);
  if (locale === "vn") {
    const month = vietnameseMonths[date.getMonth()];
    return `${month}, ${date.getFullYear()}`;
  }
  const month = date.toLocaleString("default", { month: "long" });
  return `${month} ${date.getDate()}, ${date.getFullYear()}`;
};

export const getLinkTarget = url => {
  const isExternal = url?.startsWith("http");

  return isExternal ? "_blank" : "_self";
};

export const MAP_LABELS = {
  en: {
    centerName: "Kohler Experience Center",
    showroomName: "KOHLER Showroom",
    dearName: "Authorized KOHLER dealer",
    storelocatorButtonLabel: "Search",
    searchLabel: "Find a store",
    starDealer: "Authorized KOHLER Star Dealer",
  },
  th: {
    centerName: "โคห์เลอร์ เอ็กซ์พีเรียนซ์ เซ็นเตอร์",
    showroomName: "โคห์เลอร์ โชว์รูม",
    dearName: "ตัวแทนจำหน่ายโคห์เลอร์",
    storelocatorButtonLabel: "Search",
    searchLabel: "ค้นหาตัวแทนจำหน่าย",
    starDealer: "Authorized KOHLER Star Dealer",
  },
};

export const getLinkTargetTab = tabinfo => {
  return tabinfo === "New Tab" ? "_blank" : "_self";
};

export const hideContentforLocale = (locale, hideContentOn) => {
  let hideContent = false;

  switch (locale) {
    case "th":
      hideContent = hideContentOn === "th" ? true : false;
      break;

    case "en":
      hideContent = hideContentOn === "en" ? true : false;
      break;

    default:
      hideContent = false;
  }
  return hideContent;
};

export const scrollToTop = div => {
  document.querySelector(`.${div}`)?.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
  // scroller.scrollTo("plp-section", {
  //       duration: 2000,
  //       smooth: "easeInOutQuart",
  //     });
};

export const getLocalizedValue = (storeObject, fieldName, locale = "en") => {
  const isEnglish = locale?.startsWith("en");
  return isEnglish
    ? storeObject?.[fieldName]
    : storeObject?.[`${fieldName}Alternate`] || storeObject?.[fieldName];
};
